import CurrentEntityState from "./states/CurrentEntityState";
import AppContextState from "./states/AppContextState";
import LoginFlowState from "./states/LoginFlowState";
import InvitationState from "./states/InvitationState";
import CurrentStudyState from "./states/CurrentStudyState";
import { clearSession } from "@hooks/useSession";
import NavigationService from "@services/navigation.service.js"
import {v4 as uuidv4} from "uuid";


const states = {
  CurrentEntityState,
  AppContextState,
  LoginFlowState,
  InvitationState,
  CurrentStudyState,
}

const _useStatesAuthorization = uuidv4();

// --- Listener system -----------------------------
// Map<keyName, Set<callback>>
const listeners = {};

/**
 * Register a callback that will be invoked when the given key is updated via State.setValue.
 * @param {string} keyName                         – The state key to listen to.
 * @param {(newValue:any, oldValue:any)=>void} cb – Callback executed after the value changes.
 */
const registerListener = (keyName, cb) => {
  if (typeof cb !== "function" || !keyName) return;
  if (!listeners[keyName]) listeners[keyName] = new Set();
  listeners[keyName].add(cb);
};

/**
 * Unregister a previously registered callback for a given key.
 */
const unregisterListener = (keyName, cb) => {
  if (!listeners[keyName]) return;
  listeners[keyName].delete(cb);
};

const notifyListeners = (keyName, newValue, oldValue) => {
  if (!listeners[keyName]) return;
  listeners[keyName].forEach((cb) => {
    try {
      cb(newValue, oldValue);
    } catch (err) {
      console.error("State listener error", err);
    }
  });
};
// --------------------------------------------------


const Obj = {};
let _STATE;
let STATE;

Object.defineProperty(Obj, "STATE", {
  get: () => {
    console.log('=== STATE === State.js === key: 607392 ===');
    console.dir(_STATE, { depth: null, colors: true })
    console.log('=================================');
    return _STATE;
  },
  set: () => {
    throw new Error("You cannot set the state directly");
  },
});

const mappingKeysObject = {}

Object.values(states).forEach(state => {
  Object.values(state.KEYS).forEach(key => {
    if(mappingKeysObject[key]){
      console.error("Key already exists:", key);
    }
    mappingKeysObject[key] = state;
  })
})

console.log('=== mappingKeysObject === State.js === key: 869354 ===');
console.dir(mappingKeysObject, { depth: null, colors: true })
console.log('=================================');

const reloadState = ()=>{
  _STATE = Object.values(states).reduce((acc, state) => {
    return {
      ...acc,
      ...state.reloadState(_useStatesAuthorization),
    };
  }, {});
  STATE = Obj["STATE"];
  Object.freeze(STATE);
}

const setValue = (keyName, value) => {
  if (!mappingKeysObject[keyName]) {
    return {
      success: false,
      message: "Key not found",
      fromError: null,
      errorCode: "key-not-found-error",
      errorKey: 607532,
    };
  }
  
  const oldValue = _STATE[keyName]||null;
  mappingKeysObject[keyName].setValue(_useStatesAuthorization,keyName, value);
  reloadState();
  notifyListeners(keyName, value, oldValue);
  return {
    success: true,
    message: "Value set successfully",
    fromError: null,
    errorCode: "value-set-successfully",
    errorKey: 695117,
  };
};

const getValue = (keyName = "") => {
  reloadState();
  return _STATE[keyName] || null;
};

const getState = () => {
  reloadState();
  return _STATE;
};



const reset = (StateToReset = null)=>{
    if(StateToReset){
      StateToReset.reset(_useStatesAuthorization);
      reloadState();
      return;
    }
    Object.values(states).forEach(state => state.reset(_useStatesAuthorization));
    reloadState();
}

const State = {
  reset,
  setValue,
  registerListener,
  unregisterListener,
};

Object.values(states).forEach(state => state.init({ authorize: _useStatesAuthorization }));

reloadState(); 



export default State;
export {
  //exporter le contenu de Obj["STATE"] sous le nom de STATE
  STATE,
  CurrentEntityState,
  AppContextState,
  LoginFlowState,
  InvitationState,
  CurrentStudyState,
}
